<template>
    <v-col class="pa-6">
        <div v-if="!viewingActivity">
            <v-row>
                <v-col cols="12" md="4">
                    <v-text-field class="input" label="Search..." prepend-inner-icon="mdi-magnify" rounded
                        v-model="search"></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                    <v-row class="ma-0" justify="center" justify-md="start">
                        <v-select v-model="selectedStatus" :items="statusTypes" class="input" style="max-width: 240px"
                            label="Selected Status Type" rounded></v-select>
                    </v-row>
                </v-col>
            </v-row>
            <v-row justify="center">
                <v-data-table no-data-text="No activities yet" style="width: 100%" :headers="headers"
                    :items="filteredActivity" :items-per-page="10" class="elevation-1 ml-4 mr-8">
                    <template v-slot:item.action="{ item }">
                        <td>
                            <v-icon color="#4390c0" @click="viewActivity(item)">mdi-eye</v-icon>
                        </td>
                    </template>
                </v-data-table>
            </v-row>
        </div>
        <div v-if="viewingActivity">
            <ViewActivity :activity="selectedActivity" @close="handleClose()" />
        </div>
    </v-col>
</template>

<script>
import ViewActivity from "@/components/ViewActivity.vue";

import {
    collection,
    getDocs,
    where,
    getFirestore,
    query,
    getDoc,
    doc,
    addDoc,
} from "firebase/firestore";
import { firebaseApp } from "../../firebaseConfig";
const db = getFirestore(firebaseApp);

export default {
    data() {
        return {
            headers: [
                {
                    text: "Date",
                    value: "date",
                },
                {
                    text: "Time",
                    value: "startTimeFormatted",
                },
                {
                    text: "Client",
                    value: "clientFullName",
                },
                // { text: "Email Address", value: "client.email" },
                { text: "Patients", value: "patientName" },
                { text: "Doctor", value: "doctorFullName" },
                {
                    text: "Type",
                    value: "consultType",
                },
                { text: "Action", value: "action" },
            ],
            viewingActivity: false,
            activities: [],
            clients: [],
            doctors: [],
            admins: [],
            selectedActivity: null,
            search: "",
            selectedStatus: 'Pending',
            statusTypes: ['Pending', 'Refunded', 'Denied'],
        };
    },
    components: {
        ViewActivity,
    },
    async created() {
        let res = await this.getClients();
        let res2 = await this.getDoctors();
        let res3 = await this.getAdmins();
        let res4 = await this.getActivities();

        if (localStorage.getItem("ViewedActivity")) {
            let selectedActivity = JSON.parse(localStorage.getItem("ViewedActivity"));
            let newActivity = this.activities.find(activity => activity.id == selectedActivity.id);

            if (newActivity) {
                this.selectedActivity = newActivity;
                this.viewingActivity = true;
            }
        }
    },
    methods: {
        handleClose() {
            this.viewingActivity = false;
            localStorage.removeItem('ViewedActivity');
        },
        async getActivities() {
            try {
                let q = query(collection(db, "consultations"));

                this.loading = true;
                const querySnapshot = await getDocs(q);
                this.loading = false;

                this.activities = [];

                const clientMap = Object.fromEntries(
                    this.clients.map(c => [c.id, c])
                );

                const doctorMap = Object.fromEntries(
                    this.doctors.map(d => [d.id, d])
                );

                querySnapshot.docs.forEach((doc) => {
                    if (doc.data().refundRequested) {
                        let tempActivity = doc.data();
                        tempActivity.id = doc.id;

                        // Find client
                        const client = clientMap[tempActivity.clientID];
                        if (client) {
                            tempActivity.client = client;
                            tempActivity.clientFullName = `${client.firstName} ${client.lastName}`;
                        } else {
                            tempActivity.clientFullName = 'Client not found';
                        }

                        tempActivity.patientName = '';

                        if (!tempActivity.patient.type) {
                            tempActivity.patientName = tempActivity.patient.firstName + ' ' + tempActivity.patient.lastName;
                        } else {
                            tempActivity.patientName = tempActivity.patient.name;
                        }

                        // Find doctor
                        const doctor = doctorMap[tempActivity.doctorID];
                        if (doctor) {
                            tempActivity.doctor = doctor;
                            tempActivity.doctorFullName = `${doctor.name} ${doctor.surname}`;
                        } else {
                            tempActivity.doctorFullName = 'Doctor not found';
                        }

                        if (tempActivity.disputes) {
                            tempActivity.disputes.forEach(dispute => {
                                if (dispute.userType == 'Admin') {
                                    dispute.admin = this.admins.find(admin => admin.id == dispute.userID);
                                }
                            });
                        }

                        this.activities.push(tempActivity);
                    }
                });
            } catch (error) {
                this.loading = false;
                console.log("error: ", error);
            }
        },
        async getDoctors() {
            try {
                let q = query(collection(db, "doctors"));

                this.loading = true;
                const querySnapshot = await getDocs(q);
                this.loading = false;

                this.doctors = [];

                querySnapshot.docs.forEach((doc) => {
                    let tempDoctor = doc.data();
                    tempDoctor.id = doc.id;

                    this.doctors.push(tempDoctor);
                });
            } catch (error) {
                this.loading = false;
                console.log("error: ", error);
            }
        },
        async getClients() {
            try {
                let q = query(collection(db, "clients"));

                this.loading = true;
                const querySnapshot = await getDocs(q);
                this.loading = false;

                this.clients = [];

                querySnapshot.docs.forEach((doc) => {
                    let tempClient = doc.data();
                    tempClient.id = doc.id;

                    this.clients.push(tempClient);
                });
            } catch (error) {
                this.loading = false;
                console.log("error: ", error);
            }
        },
        async getAdmins() {
            try {
                let q = query(collection(db, "dashboardUsers"));

                this.loading = true;
                const querySnapshot = await getDocs(q);
                this.loading = false;

                this.admins = [];

                querySnapshot.docs.forEach((doc) => {
                    let tempAdmin = doc.data();
                    tempAdmin.id = doc.id;

                    this.admins.push(tempAdmin);
                });
            } catch (error) {
                this.loading = false;
                console.log("error: ", error);
            }
        },
        viewActivity(activity) {
            this.selectedActivity = activity;
            this.viewingActivity = true;
        },
    },
    computed: {
        filteredActivity() {
            return this.activities.filter((item) => {
                // Filter by status if selectedStatus is not null
                let matchesStatus =
                    this.selectedStatus === null || item.status === this.selectedStatus;

                if (this.selectedStatus == 'Denied' && item.refundDenied) {
                    matchesStatus = true;
                }

                // Filter by search text
                const matchesSearch = Object.values(item).some((value) => {
                    if (value !== null && value !== undefined) {
                        return value
                            .toString()
                            .toLowerCase()
                            .includes(this.search.toLowerCase());
                    }
                    return false;
                });

                // Only return items that match both filters
                return matchesStatus && matchesSearch;
            }).sort((a, b) => {
                const dateA = new Date(`${a.date}T${a.startTime}`);
                const dateB = new Date(`${b.date}T${b.startTime}`);
                return dateB - dateA; // descending (latest first)
            });
        },
    },
};
</script>

<style scoped></style>